export default "__VITE_ASSET__c1fCQl84__"